import plans from '@/plans';

export const defFilter = (list, filterKeys = []) => {
    return filterKeys.filter(Boolean).map(key => {
        const keys = key.split('$');
        const key0 = keys[0];
        // priority: ZOOM_MEETING$BIZ_PLUS fallback to ZOOM_MEETING
        return list.find(x => x.key === key) || list.find(x => x.key === key0);
    }).filter(Boolean);
};

export default {
    props: {
        filter: {
            type: Function,
            default: defFilter,
        },
        filterKeys: {
            type: Array,
            default: () => [],
        },
        configPlanTileStatus: {
            type: Object,
            default: () => ({}),
        }
    },
    render(h) {
        const filter = window.__hook_plans_filter__ || this.filter;
        return h(
            'div',
            {},
            filter(plans, this.filterKeys).map(x => h(x.components?.config, {
                key: x.key,
                props: {
                    configPlanTileStatus: this.configPlanTileStatus,
                    isAddon: !!x.components?.addon,
                },
                on: {
                    ...this.$listeners
                }
            })),
        );
    },
};
